<template>
  <div class="course-card" @click="goToCourseDetail(courseProps.courseId)">
    <div class="course-card-header">
      <div class="course-card-title">
        {{ courseProps.title[0].val.toUpperCase() }}
      </div>
      <p class="course-card-subtitle">{{ courseProps.name[0].val }}</p>
      <div style="margin-top:7.5px">

      </div>
      <p class="course-card-courseDetail">
        <span style="font-weight:bold">AcademicYear :</span> <span style="margin-left: 10px">{{ courseProps.academicYear }}</span>
        <br>
        <span style="font-weight:bold">Semester :</span> <span style="margin-left: 10px">{{ courseProps.semester }}</span>
      </p>
      <!-- <p class="course-card-courseDetail">
        <span style="font-weight:bold">Section :</span> <span style="margin-left: 24px">{{ courseProps.section[0].code }}</span>
      </p> -->
    </div>

    <img src="@/assets/images/admin/dot1.png" width="100%" />
    <div class="course-card-body">
      <div>
        <div class="course-card-body-row">
          <div style="font-size:12px; font-weight: 400;">Enrolled</div>
          <div style="font-size:12px; font-weight: 400;">Completed</div>
        </div>
        <div class="course-card-body-row">
          <div>{{ sumOfEnrolled }}</div>
          <div>{{ sumOfCompleted }}</div>
        </div>
      </div>
      <div>
        <div class="course-card-body-row">
          <div style="font-size:12px; font-weight: 400;">Posted</div>
          <div></div>
        </div>
        <div class="course-card-body-row">
          <div>0</div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "courseCardOverview",
  props: {
    courseProps: Object,
  },
  data() {
    return {
      sumOfEnrolled: 0,
      sumOfCompleted: 0,
    };
  },
  create() {
    this.$store.commit("language/setChangingSidebar", true);
  },
  mounted() {
    this.sumEnrolled();
    this.sumCompleted();
  },
  // computed: {
  //   ...mapGetters({
  //     instructorCoursesGetter: "courses/getInstructorsCourse",
  //   }),
  // },
  // watch: {
  //   instructorCoursesGetter(value) {
  //     this.instructorCoursesData = value;
  //     this.$store.commit("necessary/setInstructorSection", this.instructorCoursesData[0].section)
  //     console.log(this.instructorCoursesData[1].section);
  //   },
  // },
  methods: {
    goToCourseDetail(courseCode) {
      const nameArray = this.courseProps.name || (this.courseProps.controls && this.courseProps.controls.name);
      const sem = this.courseProps.semester || (this.courseProps.controls && this.courseProps.controls.semester);
      const year = this.courseProps.academicYear || (this.courseProps.controls && this.courseProps.controls.academicYear);

      let body = {
        courseId: courseCode,
        courseName: nameArray && nameArray[0] ? nameArray[0].val : "No Name",
        section: this.courseProps.section,
        semester: sem,
        academicYear: year,
      };

      this.$store.commit("necessary/setInstructorSection", this.courseProps.section)
      this.$store.commit("courses/setCourseId", body);
      this.$router.push("/course-management/course-detail");
    },
    sumEnrolled() {
      let sumHolderOld = 0;
      let sumHolderNew = 0;
      let enrolledSectionCounter = this.courseProps.section.length;

      for (let i = 0; i < enrolledSectionCounter; i++) {
        sumHolderNew = this.courseProps.section[i].userEnroll;
        let sumHolder = this.courseProps.section[i].userEnroll + sumHolderOld;
        sumHolderOld = sumHolder;
      }
      this.sumOfEnrolled = sumHolderOld;
    },
    sumCompleted() {
      let sumHolderOld = 0;
      let sumHolderNew = 0;
      let enrolledSectionCounter = this.courseProps.section.length;
      for (let i = 0; i < enrolledSectionCounter; i++) {
        sumHolderNew = this.courseProps.section[i].userComplete;
        let sumHolder = this.courseProps.section[i].userComplete + sumHolderOld;
        sumHolderOld = sumHolder;
      }
      this.sumOfCompleted = sumHolderOld;
    },
  },
};
</script>
<style scoped>
.course-card-courseDetail {
  white-space: nowrap;
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis !important;
  margin-bottom: 0;
  font-weight: lighter;
  font-size: 14px;
}
</style>
